<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
// import {systemInfoByIP} from '../../utils'
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
  },
  // watch:{
  //   "$route":function(oldV,newV){
  //      setTimeout(()=>{
  //        if(localStorage.useWaterMark==1) this.initDrawWatermark();
  //      },500)
  //   }
  // },
  //  mounted(){
  //   if(localStorage.useWaterMark==1) this.initDrawWatermark();
  // },
  // methods:{
  //    initDrawWatermark(){
  //     var str="";
  //     if(localStorage['user-name']){
  //       str=localStorage['user-name']+" ";
  //       str+=this.utils.parseTime(new Date(),'{y}-{m}-{d} {h}:{i}:{s}')
  //     }else{
  //       str=systemInfoByIP().systemName
  //     }
  //     this.drawWatermark({watermarl_element:"appWaterMask","watermark_txt":str})
  //   },
  //    drawWatermark(settings){
  //     //默认设置
  //     var defaultSettings={
  //       watermark_txt:settings.watermark_txt||'',
  //       watermark_x:5,//水印起始位置x轴坐标
  //       watermark_y:5,//水印起始位置Y轴坐标
  //       watermark_rows:10,//水印行数
  //       watermark_cols:2,//水印列数
  //       watermark_x_space:-60,//水印x轴间隔
  //       watermark_y_space:30,//水印y轴间隔
  //       watermark_color:'#aaa',//水印字体颜色
  //       watermark_alpha:0.2,//水印透明度
  //       watermark_fontsize:'15px',//水印字体大小
  //       watermark_font:'微软雅黑',//水印字体
  //       watermark_width:250,//水印宽度
  //       watermark_height:160,//水印长度
  //       watermark_angle:15//水印倾斜度数
  //     };
  //     //采用配置项替换默认值，作用类似jquery.extend
  //     if(arguments.length===1&&typeof arguments[0] ==="object" )
  //     {
  //       var src=arguments[0]||{};
  //       for(var key in src)
  //       {
  //         if(src[key]&&defaultSettings[key]&&src[key]===defaultSettings[key])
  //           continue;
  //         else if(src[key])
  //           defaultSettings[key]=src[key];
  //       }
  //     }
  //
  //     var oTemp = document.createDocumentFragment();
  //     var maskElement=document.getElementById(settings.watermarl_element)||document.body;
  //     if(settings.watermarl_element){
  //       maskElement.style.position = "fixed";
  //       maskElement.style.left = "0";
  //       maskElement.style.right = "0";
  //       maskElement.style.top = "80px";
  //       maskElement.style.bottom = "0";
  //       maskElement.style.overflow = "hidden";
  //       maskElement.style.zIndex = "99";
  //       maskElement.style.pointerEvents='none';//pointer-events:none  让水印不遮挡页面的点击事件
  //     }
  //     //获取页面最大宽度
  //     var page_width = Math.max(document.body.scrollWidth,document.body.clientWidth);
  //      defaultSettings.watermark_cols=parseInt(page_width/(settings.watermark_txt.length*15+defaultSettings.watermark_x_space))
  //      defaultSettings.watermark_width=settings.watermark_txt.length*15;
  //     //获取页面最大高度
  //     var page_height = Math.max(document.body.scrollHeight,document.body.clientHeight)+450;
  //     if (defaultSettings.watermark_rows == 0 || (parseInt(defaultSettings.watermark_y + defaultSettings.watermark_height * defaultSettings.watermark_rows + defaultSettings.watermark_y_space * (defaultSettings.watermark_rows - 1)) > page_height)) {
  //       defaultSettings.watermark_rows = parseInt((defaultSettings.watermark_y_space + page_height - defaultSettings.watermark_y) / (defaultSettings.watermark_height + defaultSettings.watermark_y_space));
  //       defaultSettings.watermark_y_space = parseInt(((page_height - defaultSettings.watermark_y) - defaultSettings.watermark_height * defaultSettings.watermark_rows) / (defaultSettings.watermark_rows - 1));
  //     }
  //     var x;
  //     var y;
  //     for (var i = 0; i < defaultSettings.watermark_rows; i++) {
  //       y = defaultSettings.watermark_y + (defaultSettings.watermark_y_space + defaultSettings.watermark_height) * i;
  //       for (var j = 0; j < defaultSettings.watermark_cols; j++) {
  //         x = defaultSettings.watermark_x + (defaultSettings.watermark_width + defaultSettings.watermark_x_space) * j;
  //
  //         var mask_div = document.createElement('div');
  //         mask_div.id = 'mask_div' + i + j;
  //         mask_div.className = 'mask_div';
  //         mask_div.appendChild(document.createTextNode(defaultSettings.watermark_txt));
  //         //设置水印div倾斜显示
  //         mask_div.style.webkitTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
  //         mask_div.style.MozTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
  //         mask_div.style.msTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
  //         mask_div.style.OTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
  //         mask_div.style.transform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
  //         mask_div.style.visibility = "";
  //         mask_div.style.position = "absolute";
  //         mask_div.style.left = x + 'px';
  //         if(j%2!=0){
  //           mask_div.style.top =y +50+ 'px';
  //         }else{
  //           mask_div.style.top = y + 'px';
  //         }
  //         mask_div.style.opacity = defaultSettings.watermark_alpha;
  //         mask_div.style.fontSize = defaultSettings.watermark_fontsize;
  //         mask_div.style.fontFamily = defaultSettings.watermark_font;
  //         mask_div.style.color = defaultSettings.watermark_color;
  //         mask_div.style.textAlign = "center";
  //         mask_div.style.width = defaultSettings.watermark_width + 'px';
  //         mask_div.style.height = defaultSettings.watermark_height + 'px';
  //         mask_div.style.display = "block";
  //
  //         oTemp.appendChild(mask_div);
  //       };
  //     };
  //     maskElement.innerHTML = "";
  //     maskElement.appendChild(oTemp);
  //   }
  // }
}
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #fff;
  border-left: 12px solid #eee;
}

.fixed-header+.app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header+.app-main {
    padding-top: 96px;//84+顶部底部border12px
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/AppMain.vue